<script lang="ts" setup="">
import type { NuxtLinkProps } from '#app'
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons'

const { variant, size, ...props } = defineProps<NuxtLinkProps & {
  variant: Exclude<ButtonIntent, 'tertiary'>
  size: ButtonSize
  dir?: 'ltr' | 'rtl'
}>()
</script>

<template>
  <NuxtLink
    class="flex items-center gap-2.5 p-2xs w-fit no-underline outline rounded-sm hover:underline"
    :class="size"
    v-bind="props"
  >
    <slot />
    <Shape variant="hexagon" class="w-9" :class="variant" :icon="dir === 'rtl' ? faArrowLeft : faArrowRight" />
  </NuxtLink>
</template>

<style scoped lang='postcss'>
a {
  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;

    @apply !text-carbon-500;

    > svg {
      @apply !fill-carbon-100 !text-carbon-500;
    }
  }

  > .primary {
    @apply fill-blurple-100 text-blurple-500;
  }

  &:has(> .primary) {
    @apply text-blurple-500;
  }

  > .secondary {
    @apply fill-moss-200 text-moss-500;
  }

  &:has(> .secondary) {
    @apply text-moss-500;
  }

  &:hover {
    > .primary {
      @apply fill-blurple-50;
    }

    > .secondary {
      @apply fill-moss-100;
    }
  }

  &:focus {
    @apply outline-4 outline-offset-0 outline-blurple-300;

    > .primary {
      @apply fill-blurple-100;
    }

    > .secondary {
      @apply fill-moss-500 text-moss-200;
    }
  }

  &.small {
    @apply text-base;
  }

  &.medium {
    @apply text-xl;
  }

  &.large {
    @apply text-2xl;
  }
}
</style>
